import React from 'react'

/**
 * @see https://reactjs.org/docs/error-boundaries.html
 *
 * cannot be refactored as hook until future react updates allow it:
 * @see https://reactjs.org/docs/hooks-faq.html#do-hooks-cover-all-use-cases-for-classes
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // do not log in test environment
    if (process.env.NODE_ENV !== 'test') {
      console.log('ErrorBoundary - state error:', error)
    }
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // do not log in test environment
    if (process.env.NODE_ENV !== 'test') {
      console.log('ErrorBoundary:', error)
      console.log('Info:', errorInfo)
    }
  }

  render() {
    if (this.state.hasError) {
      // any custom fallback UI if an error is thrown
      // e.g. <p style={{ color: 'red' }}>ErrorBoundary UI</p>
      if (this.props.view) {
        return this.props.view
      }
      return null
    }

    return this.props.children
  }
}

export default ErrorBoundary
